// pages/ExpenseView.js
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./ExpenseView.scss";
import { getExpenseByID, deleteExpense } from "../../services/api/ExpenseApi";
import {
  BiCalendarAlt, BiDollar, BiTagAlt, BiUserCheck, BiFile, BiTime, BiEdit, BiTrash
} from "react-icons/bi";
import { useLoading } from "../../context/LoadingContext";
import { formatPartyNames,formatText } from "../../components/TruncateParties";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal/DeleteConfirmationModal";
import { FiFileText } from "react-icons/fi";


const ExpenseView = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const location = useLocation();
  const { parties } = location.state || {};
  const [expense, setExpense] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const [showDeleteModal, setShowDeleteModal] = useState(false);


  useEffect(() => {
    if (id) {
      showLoading("Loading expense details...");
      getExpenseByID(id)
        .then((res) => {
          setExpense(res.data.expenses);
          hideLoading();
        })
        .catch((err) => {
          console.error("Error fetching expense:", err);
          hideLoading();
        });
    }
  }, [id]);

  if (!expense) {
    return <div className="expense-detail-container"><p className="error-message">Expense not found</p></div>;
  }

  const handleEdit = () => {
  navigate(`/home/expenses/edit/${id}`, { 
    state: { 
      expenseData: expense,
      parties 
    } 
  })
}
  const handleDelete = () => {
    setShowDeleteModal(true);
  }
  const confirmDelete = async () => {
    try {
      await deleteExpense(id);
      navigate('/home/expenses')
    } catch (err) {
      console.error("Error deleting expense:", err);
    }
  }

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  return (
    <div className="expense-detail-container">
      <div className="expense-card">
        <div className="expense-header">
          <div className="expense-header-data">
            <div className="avatar">
              {expense.typeOfResource?.charAt(0).toUpperCase() || "E"}
            </div>
            <div className="expense-title">
              <h2>{formatText(expense.typeOfResource || "Expense Detail")}</h2>
              <span className="expense-tag">{expense.type}</span>
            </div>
          </div>
          <div className="client-actions">
            <button className="btn-update" onClick={handleEdit}>
              <BiEdit /> Update
            </button>
            <button className="btn-delete" onClick={handleDelete}>
              <BiTrash /> Delete
            </button>
          </div>
          
        </div>

        <div className="expense-details-grid">
          <div className="exp-detail-item">
            <BiCalendarAlt className="icon" />
            <div>
              <label>Date</label>
              <p>{new Date(expense.date).toLocaleDateString()}</p>
            </div>
          </div>

          <div className="exp-detail-item">
            <BiDollar className="icon" />
            <div>
              <label>Amount</label>
              <p>₹{expense.amount}</p>
            </div>
          </div>

          {expense.courtRef && (
            <div className="exp-detail-item" onClick={(e) => { e.stopPropagation(); navigate(`/home/cases/casedetails/${expense.courtRef}`) }} style={{ cursor: 'pointer' }}>
              <BiFile className="icon" />
              <div>
                <label>Court Ref</label>
                <p>{formatPartyNames(parties)} - ({expense.courtRef})</p>
              </div>
            </div>
          )}

          {expense.resourceName && (
            <div className="exp-detail-item">
              <BiUserCheck className="icon" />
              <div>
                <label>Resource</label>
                <p>{formatText(expense.resourceName)}</p>
              </div>
            </div>
          )}

          <div className="exp-detail-item">
            <BiTime className="icon" />
            <div>
              <label>Created At</label>
              <p>{new Date(expense.createdAt).toLocaleString()}</p>
            </div>
          </div>

          <div className="exp-detail-item">
            <BiEdit className="icon" />
            <div>
              <label>Updated At</label>
              <p>{new Date(expense.updatedAt).toLocaleString()}</p>
            </div>
          </div>
        </div>

          <div className="exp-detail-item any-desc exp-desc">
            <FiFileText className="icon" />
            <div>
              <label>Description</label>
              {expense.description ? (
                <p>{expense?.description}</p>
              ): (
                <p>No description provided</p>
              )}
            </div>
          </div>

        {expense.document && (
          <div className="expense-document">
            <a href={expense.document} target="_blank" rel="noopener noreferrer">
              View Document
            </a>
          </div>
        )}
      </div>
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        itemType="expense"
        onCancel={cancelDelete}
      />


    </div>
  );
};

export default ExpenseView;